export class VerifyCodeService {
	Verify(endpoint, code, token, recaptcha) {
		return this._FetchProvider()(endpoint, {
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify({ code, token, recaptcha })
		})
			.then((response) => {
				if (response.ok) {
					return response.json();
				}
				else {
					return response.text().then((text) => {
						throw new Error(text);
					});
				}
			})
			.then((result) => {
				if (!!result.success) {
					return { token: result.success };
				}
				else {
					return { errMessage: result.errMessage };
				}
			});
	}

	/* istanbul ignore next */
	_FetchProvider() {
		return fetch;
	}
}
